<template>
  <div  style="width: 1000px;margin:0 auto;" v-if="getDetailFinish">
    <div class="outWrapper">审批详情
        <span style="color: #d33d6a;" v-if="approval_status=='已终止' || approval_status=='审批失败'">({{approval_status}})</span>
        <span v-if="approval_status=='已完成'">({{approval_status}})</span>
        <span v-if="approval_status=='待审中'">({{approval_status}})</span>
    </div>
        <!-- <span style="color: red;" v-if="approval_status=='已终止'">({{approval_status}})</span></div> -->
    <!--不可修改-->
     <div class="content1">
      <!-- <div  class="info">
        <label class="items_name">项目名称:</label>
        <span class="content">
               {{dataInit.project_id.name}}
        </span>
      </div> -->
      <div :key="index+''" v-for="(item,index) in templates"  v-if="item.key_name != ''|| item.key_name != null" class="info">
          <span v-if="item.type == 'input' || item.type == 'text'" >
            <label class="items_name">{{item.name}}:</label>
            <span class="content" v-html="dataInit[item.key_name]">
                   {{dataInit[item.key_name]}}
            </span>
          </span>

         <span v-if="item.type == 'select' && dataInit[item.key_name].name != null" >
            <label class="items_name">{{item.name}}:</label>
            <span class="content">
                   {{dataInit[item.key_name].name}}
            </span>
          </span>

         <span v-if="item.key_name == 'cc_user_ids'">
            <label class="items_name">{{item.name}}:</label>
            <span class="content" v-for="(aa,index) in dataInit[item.key_name]" :key="index + ''">
                   {{aa.username}}
            </span>
          </span>

          <span v-if="item.key_name == 'flow_user_ids'">
            <label class="items_name">{{item.name}}:</label>
            <span class="content" v-for="(aa,index) in dataInit[item.key_name]" :key="index + ''">
                   {{aa.name}}
            </span>
          </span>
      </div>
      <!--表格-->
      <table class="biaoge_table"  cellspacing="0" cellpadding="0" border="0"  border-color='#ccc'  v-if="document_ids.length>0">
        <thead class="thead" id="planThead">
        <tr class="plansItems">
          <th width="35%">文档名称</th>
          <th width="35%">发表人</th>
          <th width="30%">操作</th>
        </tr>
        </thead>

        <tbody class="tbody" >
        <tr v-for="(item,index) in  document_ids" :key="index + ''">
          <td width="35%">{{item.name}}</td>
          <td width="35%">{{item.file.user_id}}</td>
          <td width="30%">
            <span class="function_btn" style="color: #0099CC;"   @click="download(item.file.fileurl)">下载</span>
            <span class="function_btn" style="color: #0099CC;"   @click="preview(item.file.fileurl,item.type.name)">预览</span>
          </td>
        </tr>
        </tbody>
      </table>

      <div style="margin: 10px auto;width:100%;line-height: 40px" >
        <!-- <div v-for="(item,key) in flow_user_ids">
            <div style="height: 50px;border-left: 1px solid #ccc;margin:0  0 0 30px;" v-if="key>0"></div>
            <div>
              <el-button type="primary" circle>{{item.name}}</el-button>
              <span style="margin:0 10px;" v-if="key == 0">{{item.user_id == user_info.user_id?'我':item.name}} 发起审批</span>
              <span style="margin:0 10px;" v-if="key > 0 && item.status == 1">{{item.user_id == user_info.user_id?'我':item.name}} <span style="color:#cda87c"> </span> 审批中</span>
              <span style="margin:0 10px;" v-if="key > 0 && item.status == 2 || item.status == 3">{{item.user_id == user_info.user_id?'我':item.name}} <span style="color:#cda87c"> </span></span>              
              <span class="fr">{{item.reply_time}}</span>
            </div>
        </div> -->
       
        <el-steps direction="vertical" :active="steps" style="margin:0 auto;text-align: center;" space="100px" v-if="approval_status=='待审中' || approval_status=='已完成'">
          <el-step v-for="(item,index) in flow_user_ids" :key="index + ''" icon="el-icon-success" :description="item.dec"  :title="item.name">
          </el-step>
        </el-steps>

        <el-steps direction="vertical" style="margin:0 auto;text-align: center;" space="100px" v-else>
          <el-step v-for="(item,index) in flow_user_ids" :key="index + ''" icon="el-icon-success" :description="item.dec"  :title="item.name">
          </el-step>
        </el-steps>
      </div>

      <div v-if="user_info.user_id == flow_user_current">
        <label class="items_name">审批意见:</label>
        <textarea type="text" class="input_container textarea_container" v-model="opinion" style="width: 100%;" placeholder="请输入审批意见"> </textarea>
      </div>

      <div v-if="approval_status == '待审中'" style="text-align: center;margin: 10px 0;">
            <el-button type="primary" @click=" flow_edit(2)" v-if="user_info.user_id == flow_user_current">同意</el-button>
            <el-button type="primary"  @click=" flow_edit(3)" v-if="user_info.user_id == flow_user_current">拒绝</el-button>
            <el-button type="primary" @click="transferDialogVisible = true" v-if="user_info.user_id == flow_user_current">转交</el-button>
            <el-button type="primary" @click="press_approval"  v-if="user_info.user_id == cuiban_user">催办</el-button>
            <el-button type="primary" @click="abend" v-if="user_info.user_id == flow_user_ids[0].user_id">终止</el-button>
        <div style="color: red;">
            {{sumbit_tips}}
        </div>
      </div>
    </div>

    <!--转交成功-->
    <el-dialog
      title="审批转交"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <span>修改成功</span>
      <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">关闭</el-button>
        </span>
    </el-dialog>

    <!--v-if="flow_user_current != item.user_id"-->
    <!--请输入转移人员-->
    <el-dialog
      title="审批转交"
      :visible.sync="transferDialogVisible"
      width="30%"
      center>
      <div class="transfer">
        <!-- <el-select v-model="flow_id" filterable placeholder="请输入转移人员" :multiple-limit="limit">
          <el-option
            v-if="flow_user_current != item.user_id"
            v-for="(item,key) in project_users_list"
            :key="key"
            :label="item.username"
            :value="item.user_id">
          </el-option>
        </el-select> -->
        <el-select v-model="flow_id" filterable placeholder="请输入转移人员" :filter-method="project_user_list" reserve-keyword>
          <!-- <div> -->
          <el-option
            v-for="(item,key) in project_users_list"
            :key="key"
            :label="item.username"
            :value="item.user_id"  v-if="flow_user_current != item.user_id">
          </el-option>
          <!-- </div> -->
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="flow_deliver">确 定</el-button>
          <div style="color: red;text-align: center;">{{err_tips}}</div>
      </span>
    </el-dialog>

    <!--提示框-->
    <el-dialog
      title="提示"
      :visible.sync="delDialogVisible_press"
      width="30%"
      center>
      <div>
        {{press_tips}}
      </div>
      <!--<span slot="footer" class="dialog-footer">-->
          <!--<el-button type="danger" @click="delDocuemnt">删除</el-button>-->
       <!--</span>-->
    </el-dialog>

    <!--终止框-->
    <el-dialog
      title="终止审批"
      :visible.sync="delDialogVisible_abend"
      width="30%"
      center>
      <div>
        确定终止该审批吗？
      </div>
      <span slot="footer" class="dialog-footer">
         <el-button type="primary" @click="abend">终止</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  // import store from '@/vuex/store.js';
  // import select_flow from '../components/select_flow.vue';

  export default {
    provide(){
      return {
        reload: this.reload
      }
    },
    data(){
      return {
        opinion:'',
        cc_users:[],
        tips:'',
        project_users_list:[],
        user_info:{user_id:'',username:''},
        templates:[],
        dataInit:[],
        delDialogVisible_press:false,
        document_ids:[],
        edit_params:{document_ids:[]},
        edit_params_docuemnt:{},
        documents:[],
        cc_user:[],
        cc_user_ids :[],
        user_list:[],
        document_id:'',
        fileList:[],
        flow_user_ids:[],
        flow_users:[],
        flow_user_ids_param:[],
        steps:0,
        can_flow:false,
        user_id:'',
        approval_id:'',
        delDialogVisible_abend:false,
        approval_op:false,
        cuiban:false,
        canEdit:false,
        centerDialogVisible: false,
        timer:'',
        sumbit_tips:'',
        flow_id:'',
        approval_status:"",
        getDetailFinish:false,
        transferDialogVisible:false,
        flowDialogVisible:false,
        transfer:false,
        fileDialogVisible:false,
        files:[],
        uploadurl:'',
        flow_user_current:'',
        cuiban_user:'',
        press_tips:'',
        project_id:'',
        limit:1,
        err_tips:'',
        web_token:'',
        web_url:''
      }
    },
    // store,
    methods:{
      cleartips(){
        this.tips = '';
      },
      backToLogin(){
        this.$router.push('/login');
      },
      //添加审批模板
      getTemplate:function(){
        this.$http.post(this.web_url+'/project/vue_template',{web_token:this.web_token,system:'web',model_id:'7'},{emulateJSON:true}).then(function(res){
          if(res.data.status == 'ok'){
            this.templates = res.data.data;
            this.detail();
          }else {
            this.backToLogin();
          }
        })
          .catch(function(res1){
            console.log(res1);
          });
      },
      //预览
      preview(url,type){
        let routeUrl = this.$router.resolve({
          path: "/preview",
          query: {url:url,type:type}
        });
        window.open(routeUrl .href, '_blank');
        // this.$router.push({path:'/preview',query:{item:item} })
      },
      // 催办成功提示框
      press_success(){
        this.delDialogVisible_press = true;
      },
      //审批
      flow_edit(status){
        var _this = this;
        if(this.opinion == ''){
            this.sumbit_tips = '审批意见不能为空';
            var aa = setTimeout(function () {
              _this.sumbit_tips =  '';
            },3000);
             return false;
        }
        this.$confirm('确定提交审批吗？', '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
        }).then(() => {
          this.$http.post(this.web_url+'/approval/'+this.approval_id+'/flow_edit',{web_token:this.web_token,opinion:this.opinion,status:status,flow_id:this.flow_user_ids[this.steps].id},{emulateJSON:true}).then(function(res){
          if(res.data.status == 'ok'){
            this.$router.push({path:'/blank/'+this.approval_id,query:{id:this.approval_id,type:'approval'} })
          }else if(res.data.error_code == '401'){
            this.backToLogin();
          }else {
            this.sumbit_tips =  res.data.message;
            var aa = setTimeout(function () {
              _this.sumbit_tips =  '';
            },3000);
          }
        })
        .catch(function(res1){
          console.log(res1);
        });
        
        }).catch(() => {

        }); 
      },
      //删除文档
      delDocuemnt(){
        this.$http.post(this.web_url+'/document/'+this.document_id+'/delete',{web_token:this.web_token},{emulateJSON:true}).then(function(res){
          if(res.data.status == 'ok'){
            this.delDialogVisible = false;
            this.documents();
          }else {

          }
        })
          .catch(function(res1){
            console.log(res1);
          });
      },
      handleSuccess(res){
        if(res.status == 'ok'){
          this.document_ids.push(res.data);
          console.log(this.document_ids)
          this.edit_params.document_ids.push(res.data.id);
          this.fileDialogVisible = false;
        }
      },
      handleChange(file, fileList) {
        this.edit_params_docuemnt.file_id = '';
      },
      download(url){
        window.open(url);
      },
      project_user_list(keyword){
        this.flow_id = '';
        this.project_users_list = [];
        //获取人员列表
        this.$http.post(this.web_url+'/user_list',{web_token:this.web_token,keyword:keyword},{emulateJSON:true}).then(function(res){
          if(res.data.status == 'ok'){
            this.project_users_list = res.data.data;
          }else if(res.data.error_code == '401'){
            this.backToLogin();
          }
        })
        .catch(function(res1){
          console.log(res1);
        });
      },
      //搜索文档
      getDocuments(query){
        if(query == ''){
          this.files = [];
          return false;
        }
        this.$http.post(this.web_url+'/document',{web_token:this.web_token,keyword:query,my_create:true},{emulateJSON:true}).then(function(res){
          // console.log(this.templates);
          if(res.data.status == 'ok'){
            this.documents = res.data.data.list;
            //                console.log(this.user_list )
          }else if(res.data.error_code == '401'){
            this.backToLogin();
          }
        })
          .catch(function(res1){
            console.log(res1);
          });
      },
      //搜索文件
      getFiles(query){
        if(query == ''){
          this.files = [];
          return false;
        }
        this.$http.post(this.web_url+'/file',{web_token:this.web_token,keyword:query},{emulateJSON:true}).then(function(res){
          // console.log(this.templates);
          if(res.data.status == 'ok'){
            this.files = res.data.data;
            //                console.log(this.user_list )
          }else if(res.data.error_code == '401'){
            this.backToLogin();
          }
        })
          .catch(function(res1){
            console.log(res1);
          });
      },
      getUsers3(query){
        //获取人员列表
        this.$http.post(this.web_url+'/project_user_select',{web_token:this.web_token,keyword:query,system:'PC',project_id:this.edit_params.project_id},{emulateJSON:true}).then(function(res){
          if(res.data.status == 'ok'){
            this.flow_users = res.data.data;
          }else if(res.data.error_code == '401'){
            this.backToLogin();
          }
        })
          .catch(function(res1){
            console.log(res1);
          });
      },
      //催办
      press_approval(res){
        this.$http.post(this.web_url+'/approval/'+this.approval_id+'/press',{web_token:this.web_token},{emulateJSON:true}).then(function(res){
          if(res.data.status == 'ok'){
            this.delDialogVisible_press = true;
            clearTimeout(this.timer);
            this.press_tips = '已给审批人员发起催办通知';
            this.timer = setTimeout(function () {
              this.delDialogVisible_press = false;
              this.press_tips = '';
            },2000);
          }else if(res.data.error_code == '401'){
            this.backToLogin();
          }else if(res.data.error_code == 'error'){
            clearTimeout(this.timer2);
            this.err_tips = res.data.message;
            this.timer2 = setTimeout(function () {
              this.err_tips = '';
            },2000);
          }
        })
          .catch(function(res1){
            console.log(res1);
          });
      },
      //终止
      abend(){
        this.$confirm('确定终止该审批吗？', '提示', {
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            type: 'warning'
        }).then(() => {
            this.$http.post(this.web_url+'/approval/'+this.approval_id+'/abend',{web_token:this.web_token},{emulateJSON:true}).then(function(res){
            if(res.data.status == 'ok'){
              this.$router.push({path:'/blank/'+this.approval_id,query:{id:this.approval_id,type:'approval'} })
              // this.approval_op = false;
            }else if(res.data.error_code == '401'){
              this.backToLogin();
            }else if(res.data.error_code == 'error'){
              clearTimeout(this.timer2);
              this.err_tips = res.data.message;
              this.timer2 = setTimeout(function () {
                this.err_tips = '';
              },2000);
            }
          })
          .catch(function(res1){
            console.log(res1);
          });
        }).catch(() => {

        });
       
      },
      //转交
      flow_deliver(res){
        var _this = this;
        if(this.flow_id == ''){
             clearInterval(_this.timer2);
            this.err_tips = '请填写转交人员';
            this.timer2 = setTimeout(function () {
              _this.err_tips = '';
            },2000);
            return false;
        }
        this.$http.post(this.web_url+'/approval/'+this.approval_id+'/flow_deliver',{web_token:this.web_token,flow_id:this.flow_user_ids[this.steps].id,user_id:this.flow_id},{emulateJSON:true}).then(function(res){
          if(res.data.status == 'ok'){
            this.$router.push({path:'/blank/'+this.approval_id,query:{id:this.approval_id,type:'approval'} })
          }else if(res.data.error_code == '401'){
            this.backToLogin();
          }else if(res.data.status == 'error'){
            clearInterval(_this.timer2);
            this.err_tips = res.data.message;
            this.timer2 = setInterval(function () {
              _this.err_tips = '';
            },2000);
          }
        })
        .catch(function(res1){
          console.log(res1);
        });
      },
      getUsers(query){
        this.$http.post(this.web_url+'/user_list',{web_token:this.web_token,keyword: query,system:'PC'},{emulateJSON:true}).then(function(res){
          if(res.data.status == 'ok'){
            this.user_list = res.data.data;
          }else if(res.data.error_code == '401'){
            this.backToLogin();
          }
        })
          .catch(function(res1){
            console.log(res1);
          });
      },
      detail(){
        this.$http.post(this.web_url+'/approval/'+this.approval_id,{web_token:this.web_token},{emulateJSON:true}).then(function(res){
          if(res.data.status == 'ok'){
            this.dataInit =  res.data.data;
            this.document_ids = this.dataInit.document_ids;
            this.flow_user_ids = this.dataInit.flow_user_ids;
            this.approval_status = this.dataInit.status;
            // this.project_id = this.dataInit.project_id.id;
            // this.project_detail(this.project_id);

            for(var i=0; i< this.flow_user_ids.length; i++) {
              if(this.flow_user_ids[i].status == 2 || this.flow_user_ids[i].status == 3 ){
                this.steps =  i+1;
                this.flow_user_ids[i].dec = this.flow_user_ids[i].opinion+' '+this.flow_user_ids[i].start_time;
              }else if(this.flow_user_ids[i].status == 1){
                this.flow_user_ids[i].dec = '';
              }
              if(this.approval_status == '待审中'){
                this.flow_user_ids[this.steps].dec = '待审中';
              }
            }

            if(this.approval_status == '待审中') {
              this.flow_user_current = this.flow_user_ids[this.steps].user_id;
              this.cuiban_user = this.flow_user_ids[this.steps-1].user_id;
            }
            //流程
            // this.flow_users = this.dataInit.flow_user_ids;
            // for(var i =0; this.flow_users.length > i; i++){
            //   this.flow_user_ids_param.push(this.flow_user_ids[i].user_id);
            //   this.flow_users[i].username = this.flow_users[i].name;
            // }
            this.getDetailFinish = true;

          }else if(res.data.error_code == '401'){
            this.backToLogin();
          }
        })
          .catch(function(res1){
            // console.log(res1);
          });
      },
    },
    created(){
      this.web_token = sessionStorage.getItem('web_token');
      this.user_info =JSON.parse(sessionStorage.getItem('user_info'));
      this.web_url =  sessionStorage.getItem('web_url');

      this.upload_url = this.web_url+'/document/add';
      // this.$store.state.web_token = this.$cookies.get('web_token');
      // this.$store.state.user_info = this.$cookies.get('user_info');
    // }

      this.approval_id = this.$route.params.id;
        // return false;
      this.getTemplate();
    },

  }
</script>

<style scoped>
  .add_flows .el-select{
    width: 600px;
  }
  .transfer .el-select{
    width: 100%!important;
  }
  .documents_wrapper .el-select {
    width: 80%;
  }
    .function_btn{
     display: inline-block;vertical-align: top;cursor: pointer;
     margin: 0 10px;
  }
</style>





// WEBPACK FOOTER //
// src/page/approval/approval_detai1.vue